export const MIN_ITEM_WIDTH_CELLS = 6;
export const MIN_ITEM_HEIGHT_CELLS = 4;
export const INITIAL_GHOST_GRID_DIMENSIONS = { rows: 2, columns: 3 };
